import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { ConfigKeyFE_SourceTagId, ModuleFE_Variable } from '../../../_entity.js';
import { Renderer_VariableHeader } from './renderers/Renderer_VariableHeader/Renderer_VariableHeader.js';
import { Manager_Variable } from '../../Manager_Variable/Manager_Variable.js';
import { Dialog_VariableEditor } from '../../healthcare-space/variables/Dialogs/Dialog_VariableEditor.js';
import { WorkHubItem_Variable } from '../../../search/items/variable.js';
import './Manager_WorkHub_Variable.scss';
export class Manager_WorkHub_Variable extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.tabId = nextProps.tabId;
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.readonly)
            state.renderArgs = { ...state.renderArgs, editMode: false };
        state.variable = ModuleFE_Variable.cache.unique(state.renderArgs.itemId);
        if (nextProps.renderArgs.editMode && !nextProps.renderArgs.readonly && state.variable) {
            const sourceTagId = ConfigKeyFE_SourceTagId.get();
            const sourceGroup = state.variable.tagIds?.find(group => group.key === sourceTagId);
            const tagId = sourceGroup?.value[0] ?? sourceTagId;
            Dialog_VariableEditor.show(tagId, state.variable);
            WorkHubItem_Variable.updateArgs(nextProps.tabId, { editMode: false });
        }
        return state;
    }
    render() {
        if (!this.state.variable)
            return _jsx(_Fragment, {});
        return _jsxs(LL_V_L, { className: 'manager-workhub-variable', children: [_jsx(Renderer_VariableHeader, { workHubItem: this.props.workHubItem, renderArgs: this.state.renderArgs }), _jsx(Manager_Variable, { varId: this.state.renderArgs.itemId, hideHeader: true })] });
    }
}
//# sourceMappingURL=Manager_WorkHub_Variable.js.map